import { gql } from 'graphql-request';
import { request } from '@/utilities/graphQLClient';
import type { QueryFunctionContext } from '@tanstack/react-query';

export interface CompanyStatementGQL {
  name: string;
  value: boolean;
  description: {
    description: string;
  };
  severity: 'minor' | 'major' | 'none' | null;
}

export interface CompanyStatementsGQL {
  statements: CompanyStatementGQL[];
}

export type QueryResponse =
  | { errors: Error[] }
  | { Company: CompanyStatementsGQL };

export function getQueryKey(
  canonicalUrl: string,
  names?: Readonly<string[]>
): [string, string, Readonly<string[]> | undefined] {
  return ['COMPANY_STATEMENTS', canonicalUrl || '', names || []];
}

export const queryFn = async ({
  queryKey: [_keyof, canonicalURL, names],
}: QueryFunctionContext<[string, string, Readonly<string[]> | undefined]>) => {
  const response = await request<QueryResponse>(
    gql`
      query getCompanyStatements($canonicalURL: String!, $names: [String!]) {
        Company(canonicalURL: $canonicalURL) {
          statements(names: $names) {
            name
            value
            severity
            description {
              description
            }
          }
        }
      }
    `,
    { canonicalURL, names }
  );

  if ('Company' in response) {
    return response.Company;
  }

  const firstErrorMessage = response.errors[0]?.message;
  throw new Error(firstErrorMessage ?? 'Failed to fetch Company Statements');
};
